import { render } from "./selectTipoTemporada.vue?vue&type=template&id=57568c28"
import script from "./selectTipoTemporada.vue?vue&type=script&lang=ts"
export * from "./selectTipoTemporada.vue?vue&type=script&lang=ts"
script.render = render

export default script